import * as React from 'react';
import Button from '@mui/material/Button';

import DialogActions from '@mui/material/DialogActions';

import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
import { Box, Modal, styled } from '@mui/material';

import { UseMutateFunction } from '@tanstack/react-query';
import { translateBlock } from 'i18n';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { useGetBudgetProposals } from 'routes/BudgetModule/helpers/hooks/budgetProposals';
import AssociationsGrid from './AssociationsGrid';
import { useGetResourcesByBudgetProposal } from '../helpers/dataHelpers';
import { ResourceBudgetProposalAssociationT } from 'routes/BudgetModule/config/types';
import { BudgetBys } from 'business/constants';
import { getResourceType } from 'routes/BudgetModule/helpers/budgetProposalHelpers';
import { useSelectSecondaryBudgetAxisSourceTable } from 'routes/BudgetModule/components/BudgetWithProvider/SecondaryBudgetAxisSourceTableContext';

type Props = {
    show: boolean;
    cancel: () => void;
    associations: ResourceBudgetProposalAssociationT[];
    setAssociations: DispatchState<ResourceBudgetProposalAssociationT[]>;
    confirm: UseMutateFunction;
    exercice: number;
};

const StyModal = styled(Box, {
    name: 'StyModal',
})({
    minWidth: '800px',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '4px',
    boxShadow:
        '0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)',
});

export const DraftOperationAssociationsEditModal: React.FC<Props> = ({
    show,
    cancel,
    associations,
    setAssociations,
    confirm,
    exercice,
}) => {
    const { t } = useTranslation();
    const { data: budgetProposals, isLoading: isBudgetProposalsLoading } =
        useGetBudgetProposals();
    const budgetBy =
        (budgetProposals && budgetProposals[0].by) ?? BudgetBys.GESTIONNAIRE;

    const { data: resourcesWithBp, isLoading: resourcesWithBpLoading } =
        useGetResourcesByBudgetProposal({
            budgetBy: budgetBy,
        });

    const resourceType = getResourceType(budgetBy);
    const sourceTable = useSelectSecondaryBudgetAxisSourceTable();

    return (
        <Modal open={show} onClose={cancel}>
            <StyModal>
                <>
                    <DialogTitle>
                        {t('createDraftOperation.editResourcesHeaderTitle', {
                            resourceType: translateBlock(resourceType),
                            context: sourceTable,
                        })}
                    </DialogTitle>
                    <AssociationsGrid
                        setAssociations={setAssociations}
                        initialAssociations={associations}
                        isLoading={
                            isBudgetProposalsLoading || resourcesWithBpLoading
                        }
                        budgetProposalByField={resourceType}
                        resourcesWithBp={resourcesWithBp ?? []}
                    />
                    <DialogActions>
                        <Button onClick={cancel}>{t('common.close')}</Button>
                        <Button
                            disabled={associations.length < 1}
                            onClick={() => {
                                trackEventBudget(
                                    TRACKABLE_EVENTS.budget.budgetOverview
                                        .operations.draftOperation
                                        .confirmEditAssociations,
                                    {
                                        exercice,
                                    },
                                );
                                confirm();
                            }}
                        >
                            {t('common.confirm')}
                        </Button>
                    </DialogActions>
                </>
            </StyModal>
        </Modal>
    );
};
